import { Col, Row } from "antd";
import { FC } from "react";
import styles from "./index.module.scss";
import { SearchAndFilterProps } from "./types";
// For search filter and paginate
const SearchAndFilter: FC<SearchAndFilterProps> = (props) => {
  // Init
  const {
    // performSearchHandler,
    // searchValue,
    // performFilterHandler,
    title,
    // isSearchCancel,
    // setSearch,
    // setIsSearchCancel
  } = props;

  // const userPermissions = useSelector(
  //   (state: any) => state?.userProfile?.data?.permissions
  // );

  // const isAddPermission = checkPermission(userPermissions, {
  //   permissionName: 'Users',
  //   permission: ['add'],
  // });

  // JSX
  return (
    <div className={styles["search-filter"]}>
      <div className={styles["search-filter__wrapper"]}>
        <Row justify={"space-between"}>
          <Col>
            <div className={styles["search-filter__wrapper--title"]}>{title}</div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default SearchAndFilter;
